export default "__VITE_ASSET__8Gdh1c4w__"